import { Pipe, PipeTransform } from '@angular/core';
import { Utility } from '../utils/utility';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'remainTime'
})
export class RemainTimePipe implements PipeTransform {

  constructor(private translate: TranslateService) {
  }

  transform(value: any): string {
    if (isNaN(value) || value < 0) return '';
    let x = Utility.parseSecondsToDHMS(value);
    let result = '';

    if (x.minutes) {
      result = x.minutes + ' ' + this.translate.instant('minute');
    }

    if (x.hours) {
      result = x.hours + ' ' + this.translate.instant('hour');
    }

    if (x.days) {
      result = x.days + ' ' + this.translate.instant('day');
    }
    return result;
  }

}
